export default function checkImage(src: string): boolean {
    const clearedSrc = src.split('?')[0];

    return ['jpg', 'jpeg', 'png'].includes(clearedSrc.split('.').pop()!.toLowerCase());
}
